module.exports = __webpack_public_path__ + "img/1762008374835-Y3GSLOAY.1e156b8f.png";